import type theme from '#build/ui/pagination'
import type { DeepPartial } from '@nuxt/ui'

const pagination: DeepPartial<typeof theme> = {

  slots: {
    root: '',
    list: 'flex items-center gap-[10px]',
    ellipsis: 'pointer-events-none',
    label: 'min-w-5 text-center text-lg text-(--ui-primary)',
    first: 'hidden',
    prev: 'hover:bg-(--ui-med-light-aqua) cursor-pointer disabled:cursor-not-allowe',
    item: 'h-[40px] rounded-md hover:bg-(--ui-med-light-aqua) cursor-pointer !min-w-0',
    next: 'hover:bg-(--ui-med-light-aqua) cursor-pointer disabled:cursor-not-allowed',
    last: 'hidden',
  },
}

export default pagination
